export class WorkSpace {
    id = ""
    name = ""
    color = ""
    avatar = ""
    /** @type {Space[]} **/
    spaces = []
    constructor(values={}) {
        Object.assign(this, values)
    }
}